import { render } from "./Results.vue?vue&type=template&id=32be46ad&scoped=true"
import script from "./Results.vue?vue&type=script&lang=ts"
export * from "./Results.vue?vue&type=script&lang=ts"

import "./Results.vue?vue&type=style&index=0&id=32be46ad&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-32be46ad"

export default script